export const environment = {
  production: false,
  configurationname : 'zeitdev',
  live: false /**Gibt an ob es sich um die "scharfe" Version handelt. Muss true für den späteren Release */,
  runtimeEnvironment : 'mobile', // mobile oder desktop
  demoguid: '905DBD8A-0017-4244-A91A-6D72E37BA538'
};
